// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__343Yw","colBig":"styles_colBig__1jP7b","colSmall":"styles_colSmall__FDI9K"};